import { supabase } from '../supabase';

// API endpoint to check and apply player selection cooldown
export async function checkPlayerCooldown(playerId: number, userId: number) {
  try {
    const apiUrl = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/player-cooldown`;
    
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`
      },
      body: JSON.stringify({ playerId, userId }),
    });

    // Parse the response
    const data = await response.json();

    if (!response.ok) {
      if (response.status === 429) {
        // Rate limit exceeded
        return {
          success: false,
          cooldown: true,
          remainingTime: data.remainingTime,
          error: null
        };
      }
      throw new Error(data.error || 'Failed to check cooldown');
    }

    return { 
      success: true, 
      cooldown: false,
      expiresAt: data.expiresAt,
      error: null 
    };
  } catch (error: any) {
    console.error('Error checking player cooldown:', error);
    return { 
      success: false, 
      cooldown: false,
      error: error.message 
    };
  }
}

// Fallback client-side cooldown mechanism (used if server request fails)
export function applyClientCooldown(playerId: number) {
  try {
    const currentTime = Date.now();
    const expiryTime = currentTime + 5000; // 5 seconds cooldown
    
    // Store in localStorage
    const cooldowns = getCooldownsFromStorage();
    cooldowns[playerId] = expiryTime;
    localStorage.setItem('player_cooldowns', JSON.stringify(cooldowns));
    
    return {
      success: true,
      expiresAt: expiryTime
    };
  } catch (error) {
    console.error('Error applying client cooldown:', error);
    return {
      success: false,
      error: 'Failed to apply cooldown'
    };
  }
}

// Helper function to get cooldowns from storage
function getCooldownsFromStorage(): Record<number, number> {
  try {
    const stored = localStorage.getItem('player_cooldowns');
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    console.error('Error reading cooldowns from storage:', error);
    return {};
  }
}